import { useEffect, useState } from "react";
import Card from "../components/Card.tsx";
import { collection, getDocs, orderBy, query, where } from "firebase/firestore";
import { db } from "../firebase.ts"
import React from "react";


type EventDoc = {
  title: string;
  date: any; // Firestore Timestamp
  time?: string;
  description?: string;
  published?: boolean;
  image?: { downloadURL?: string }[];
};

export default function EventsPage() {
  const [events, setEvents] = useState<Array<{ id: string; data: EventDoc }>>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        setError("");

        const q = query(
          collection(db, "Events"),
          where("published", "==", true),
          orderBy("date", "asc") // soonest first
        );

        const snap = await getDocs(q);
        setEvents(
          snap.docs.map((d) => ({ id: d.id, data: d.data() as EventDoc }))
        );
      } catch (e: any) {
        setError(e?.message || "Failed to load events");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-6">
      <h1 className="text-[#de0016] text-center text-2xl sm:text-3xl font-semibold mb-6">
        Upcoming Events
      </h1>

      {loading && <p className="text-center text-gray-600">Loading…</p>}
      {error && <p className="text-center text-red-600">{error}</p>}

      {!loading && !error && events.length === 0 && (
        <p className="text-center text-gray-600">No upcoming events yet.</p>
      )}

      <div className="mx-auto max-w-5xl grid grid-cols-1 sm:grid-cols-2 gap-5 sm:gap-6">
        {events.map(({ id, data }) => (
          <Card
            key={id}
            title={data.title}
            date={data.date?.toDate?.().toLocaleDateString() || ""}
            time={data.time || ""}
            imageUrl={data.image?.[0]?.downloadURL || ""}
            description={data.description || ""}
          />
        ))}
      </div>
    </div>
  );
}
